document.addEventListener("DOMContentLoaded", () => {

    // Diamond Type Toggle
    const typeButtons = document.querySelectorAll(".df-type-buttons button");

    typeButtons.forEach(button => {
        button.addEventListener("click", () => {
            typeButtons.forEach(btn => btn.classList.remove("active"));
            button.classList.add("active");
        });
    });

    // Shape Selector
    const shapes = document.querySelectorAll(".shape");

    shapes.forEach(shape => {
        shape.addEventListener("click", () => {
            shapes.forEach(item => item.classList.remove("active"));
            shape.classList.add("active");
        });
    });

    // Temporary Counter
    document.getElementById("diamondCount").textContent = "0 Diamonds Found";

});